module.exports = __webpack_public_path__ + "static/media/bird_fly.be235ee8.gif";